// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionArticle_section__iNvB4"};